// TODO: всего одно использование, встроить
export default function getInitialsFromName(fullname = '') {
  return fullname.split(' ').map(name => name[0]).slice(0, 2).join('');
}
